import 'react-app-polyfill/stable'
import 'core-js'
import React, { useState, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import keycloak from "./Keycloak"
import { ReactKeycloakProvider } from "@react-keycloak/web"
import { TourProvider } from '@reactour/tour'

const steps = [
  {
    selector: '.sidebar',
    content: (
      <div>
        All survey and custom questions are listed here.<br />
        <b>Click any question</b> to view its detailed report.
      </div>
    ),
    position: 'top'
  },
  {
    selector: '.editor-container',
    content: (
      <div>
        <strong>Report Editor</strong>
        <br /><br />
        Select a question to see its detailed report and insights here.
      </div>
    ),
    position: 'top'
  }
]

const Root = () => {
  const onTourComplete = () => {
    localStorage.setItem('isTourCompleted', 'true');
  };

  return (
    <TourProvider
      steps={steps}
      onClickClose={({ setIsOpen }) => {
        onTourComplete();
        setIsOpen(false);
      }}
      showBadge={false}
      showNumber={false}
      showButtons={true}
      showNavigation={true}
      showCloseButton={true}
      onFinish={onTourComplete}
      styles={{
        popover: (base) => ({
          ...base,
          backgroundColor: '#1a1a1a',
          '--reactour-accent': '#fcaf17',
          color: '#ffffff',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
        }),
        maskRect: (base) => ({
          ...base,
          borderRadius: '10px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }),
        mask: (base) => ({
          ...base,
          borderRadius: '10px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }),
        maskWrapper: (base) => ({
          ...base,
          borderRadius: '10px',
        }),
        close: (base) => ({ ...base, right: 'auto', right: 8, top: 8, color: '#ffffff' }),
        controls: (base) => ({
          ...base,
          marginTop: '20px'
        }),
        buttonNext: (base) => ({
          ...base,
          backgroundColor: '#ff4757',
          '&:hover': {
            backgroundColor: '#ff6b81'
          }
        }),
        buttonBack: (base) => ({
          ...base,
          backgroundColor: '#ff4757',
          '&:hover': {
            backgroundColor: '#ff6b81'
          }
        })
      }}
    >
      <Provider store={store}>
        <ReactKeycloakProvider
          authClient={keycloak}
          initOptions={{ onLoad: 'login-required' }}
        >
          <App />
        </ReactKeycloakProvider>
      </Provider>
    </TourProvider>
  );
};

createRoot(document.getElementById('root')).render(<Root />);

reportWebVitals();